import {RestApiService} from '../../../rest-api.service';
import {Observable} from 'rxjs';
import {BaseCollectionModel, SearchModel} from '@yasc/yasc-material-components';
import {ApiV0Fibu} from '../api.v0.fibu';
import {TaxAccountRes} from '../../../../contracts/v0/fibu/misc.contracts';

export class ApiV0FibuMisc {
    segment = '/misc';

    constructor(v0: ApiV0Fibu, private rest: RestApiService) {
        this.segment = v0.segment + this.segment
    }

    getTaxAccounts(searchModel?: SearchModel): Observable<BaseCollectionModel<TaxAccountRes>> {
        return this.rest.post<SearchModel, BaseCollectionModel<TaxAccountRes>>(
            `${this.segment}/taxAccounts`,
            TaxAccountRes,
            searchModel
        )
    }
}
